import * as React from 'react';
import { Route } from 'react-router-dom';
import Layout from './sidebar/Layout';
import { Redirect } from 'react-router-dom';

import InProgressProject from 'pages/WriterClient/InProgressProject';
import DelayedProject from 'pages/WriterClient/delayedproject';
import ValidatedProjects from 'pages/WriterClient/validatedprojects';
import { WriterClientHomePage } from '../../pages/WriterClient/Homepage';
import DetailsProject from 'pages/WriterClient/detailsproject';
import WriterClientTextDisplay from 'pages/WriterClient/WriterClientTextDisplayContent';
import Profile from 'pages/shared/Profile';

export default class WriterClientMainMenu extends React.Component {
  render() {
    return (
      <Layout>
        <Route
          path="/WriterClient/WriterMainMenu"
          render={(props) => <WriterClientHomePage {...props} reload={true} />}
        />

        <Route
          path="/WriterClient/ProjectsEnCours"
          component={InProgressProject}
        />

        <Route
          path="/WriterClient/ProjectsEnRetard"
          component={DelayedProject}
        />

        <Route
          path="/WriterClient/ProjectsValides"
          component={ValidatedProjects}
        />

        <Route
          path="/WriterClient/DetailsProject"
          component={DetailsProject}
        />

        <Route
          path="/WriterClient/TextDetails"
          component={WriterClientTextDisplay}
        />

        <Route
          path="/WriterClient/MonProfil"
          component={Profile}
        />

        <Route path="*">
          <Redirect to="/WriterClient/WriterMainMenu" />
        </Route>
      </Layout>
    );
  }
}
